import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { API_URL } from "../../ConstVariable";
import { SetError } from "../../redux-store/actions";
import MultipleDropdown from "./MultipleDropDown/MultipleDropdown";
import "./Searchbar.css";

const Searchbar = ({ setSearchData,  setSelectedCenterList, setIsFetchButtonClicked, setTableData , isFetchButtonClicked}) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();

  const GetAuthToken = async () => {
    const token = await getAccessTokenSilently();
    return token;
  };

  //NOTE:- searchDetails is local state of searchbar component
  const [searchDetails, setSearchDetails] = useState({
    startDate: "",
    endDate: "",
    centerId: [],
  });



  const [showDropDown, setShowDropDown] = useState(false);
  const [finalArray, setFinalArray] = useState([]);
  const [searchResponse, setSearchResponse] = useState(false);
  const [rerender, setRerender] = useState(false);

  //NOTE:- here we are updating the selectedCenter list data, whenever centerId changes , This useEffect runs
  useEffect(() => {
    setSelectedCenterList(searchDetails.centerId);
  }, [searchDetails.centerId]);

  const ApiCallHandler = async () => {
    if(isFetchButtonClicked){
      return 
    }
    setRerender(!rerender);
    // if We don't select from date and end date , then we return from this point
    if (searchDetails.startDate == "" || searchDetails.endDate == "") {
      return;
    }

    let token = await GetAuthToken();
    setIsFetchButtonClicked(true)

    setSearchResponse(true);

    setShowDropDown(true);
    setTableData([])
    let arr = [];
    let centerIdList = searchDetails.centerId;
    // console.log("centerIdList", centerIdList);
    for (let i = 0; i < centerIdList.length; i++) {
      arr.push(centerIdList[i].id);
    }
    var sendData = {
      startDate: searchDetails.startDate,
      endDate: searchDetails.endDate,
      centerIdList: arr,
    };

    sendData = JSON.stringify(sendData);
    // console.log("SendData", sendData);
    axios
      .post(
        `${API_URL}/oi/api/v2/getOrdersStats`,
        {
          start_date: searchDetails.startDate,
          end_date: searchDetails.endDate,
          center_ids: arr,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true
        }
      )
      .then((res) => {
     
        setSearchResponse(false);
        setShowDropDown(false);
        if( typeof res.data === 'object' && !Array.isArray(res.data) && res.data !== null){
          setIsFetchButtonClicked(false)
          console.log("Stats Data", res.data)
          setSearchData(res.data);
          setTableData(res.data.center_details)
        }
      }).catch(error=>{
        setIsFetchButtonClicked(false)
        setSearchResponse(false)
        dispatch(SetError({
            severity: "warning",
            message: error.message,
        }))

        console.log("Failed to fetch the stats", error)
      });
  };
  //This InputChangeHandler function handles the input parameters
  const InputChangeHandler = (e) => {
    setSearchDetails({
      ...searchDetails,
      [e.target.name]: e.target.value,
    });
  };

  // console.log("SearchDetails  ", searchDetails);

  return (
    <div
      className="searchbar"
      style={{ color: "black", display: "flex", alignItems: "center" }}
    >
      <div className="searchbar_startdate">
        <div style={{ fontSize: "15px", fontWeight: "500" }}>Start Date</div>
        <input
          type="date"
          className="dateInput"
          name="startDate"
          onChange={InputChangeHandler}
          // max={searchDetails.endDate}
        />
      </div>
      <div className="searchbar_enddate">
        <div style={{ fontSize: "15px", fontWeight: "500" }}>End Date</div>
        <input
          type="date"
          className="dateInput"
          name="endDate"
          onChange={InputChangeHandler}
          // min={searchDetails.startDate}
        />
      </div>
      <div style={{ marginRight: "15px" }}>
        <p style={{ marginBottom: "0px", fontSize: "15px", fontWeight: "500" }}>
          Center
        </p>
        <MultipleDropdown
          setSelectedCenterList={setSelectedCenterList}
          showCenterDropdown={showDropDown}
          setSearchDetails={(val) =>
            setSearchDetails({ ...searchDetails, ["centerId"]: val })
          }
          rerender={rerender}
        />
      </div>

      <div className="searchbar_fetch">
        <button
          className="btn btn-primary"
          type="button"
          onClick={ApiCallHandler}
        >
          {!searchResponse ? (
            <span style={{ fontWeight: "bold", fontSize: "12px" }}>Fetch</span>
          ) : (
            <span>
              {" "}
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Searchbar;
